// 工程项目
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/工程.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 工程项目质量全面提升过程咨询
        </p>
      </div>

      <h1 class="title">工程项目质量全面提升过程咨询</h1>
      <p class="jianjie">
        以工程项目为服务对象，以鲁班奖创建为目标，通过
        了解项目基本情况、匹配专家、拟定咨询建议书，四次现场和若干次在线
        和现场节点咨询，为客户提供技术、质量、安全、绿色施工、科技创新、管
        理提升等全过程技术支持，帮助客户强化质量意识、改善管理、完善工艺，
        持续改进、过程提升、一次成优。
      </p>
      <div class="one">
        <div class="oneimg"></div>
        <p>
          委托方需按照要求提供：工程类别、投资规模或建筑面积、使用功能、工期
          等资料，以及项目部组织构架、人员组成，技术、质量、安全、节能环保等体
          系建设，创优策划书和保证措施。经系统评估，筛选符合咨询条件的项目，纳
          入咨询服务。
        </p>
        <p>
          根据工程的类别、特点、难点、分部区域，匹配相应的咨询专
          家。专家在查阅委托方提供的施工组织设计、施工方案和相关资料的基础上，
          初步分析该工程应控制的重点部位、关键工艺及对应的施工方案编制情况，与
          委托方初步沟通，了解需求，制定咨询计划书。
        </p>
      </div>
      <div class="two">
        <div class="twoimg"></div>
        <p>
          对委托方提交的设计方案、施工组织设计、地基基础施工方案、技术质量安全、
          绿色施工、节能环保、信息化等策划书提出优化建议。查看现场，与相关人员
          面对面交流，回答委托方提出的问题，指出现场作业存在的问题和解决方案。
          查阅相关技术资料，有针对性地做一次专题培训，并对后续施工过程中应该注
          意的问题给予提示和指导，提交二阶段咨询建议书。
        </p>
      </div>
      <div class="three">
        <div class="threeimg"></div>
        <p>
          查看地基基础、主体结构的实体质量，查看各分部分项工程的样板实施情况；
          核查上一阶段问题整改和建议落实情况；了解项目在新技术应用、质量安全、
          绿色施工、节能环保、持续改进等方面的实施情况；与现场人员面对面交流，
          指出问题，提出改进建议和实施方法；查阅技术资料，就下一步主体结构、装
          饰装修（附属设施）和机电设备安装应注意的问题，提出相应的对策建议和预
          控措施。提交三阶段咨询建议书。
        </p>
      </div>
      <div class="four">
        <div class="fourimg"></div>
        <p>
          查看主体结构实体质量，检查分部分项工程的样板；核查上一阶段问题整改
          和建议落实情况；了解项目在科技创新、信息技术、新型建造方式等方面应
          用情况；与现场人员面对面交流，指出问题，提出整改建议；查阅技术资料
          ，就下一步装饰装修（附属设施）和机电设备作业提出优化建议。提交
          四阶段咨询建议书。
        </p>
      </div>
      <div class="five">
        <div class="fiveimg"></div>
        <p>
          查看工程的实体质量，查阅内业资料，协助总结该工程在质量安全管理、节
          能环保、绿色施工、科技进步、技术创新、信息化、新型建造方式等方面的先
          进做法，提出提升建议和意见。提交咨询报告。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/工程.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    // padding: 0px 3.6px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
      p {
        font-size: 12px;
        text-indent: 0;
        line-height: 36px;
        color: #666666;
      }
    }
    .title {
      opacity: 1;
      font-size: 35px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
    }
    .jianjie {
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 30px;
      text-align: justifyLeft;
      color: #231815;
    }
    .one {
      margin-top: 62px;
    }
    .two {
      margin-top: 83px;
    }
    .three {
      margin-top: 118px;
    }
    .four {
      margin-top: 119px;
    }
    .five {
      margin-top: 116px;
      margin-bottom: 134px;
    }
  }
}
p {
  text-indent: 2em;
  line-height: 35px;
  opacity: 1;
  font-size: 14px;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  text-align: justifyLeft;
  color: #333333;
}
.oneimg {
  width: 356px;
  height: 43px;
  background: url("../assets/img/工程项目/第一阶段@2x.png") center no-repeat;
  background-size: cover;
  margin-bottom: 31px;
}
.twoimg {
  width: 455px;
  height: 43px;
  background: url("../assets/img/工程项目/第二阶段@2x.png") center no-repeat;
  background-size: cover;
  margin-bottom: 31px;
}
.threeimg {
  width: 455px;
  height: 43px;
  background: url("../assets/img/工程项目/第三阶段@2x.png") center no-repeat;
  background-size: cover;
  margin-bottom: 31px;
}
.fourimg {
  width: 747px;
  height: 43px;
  background: url("../assets/img/工程项目/第四阶段.png") center no-repeat;
  background-size: cover;
  margin-bottom: 31px;
}
.fiveimg {
  width: 455px;
  height: 43px;
  background: url("../assets/img/工程项目/第五阶段@2x.png") center no-repeat;
  background-size: cover;
  margin-bottom: 31px;
}
</style>
